/** ***
------------------------------------------------------------------------
SNYK DISCOVERY LIST PAGE
------------------------------------------------------------------------
  imageId: "sha256:44d6af1278b33834cfbcf5d9b6ed7f47a1a0dedbf5054e590a6cb1e140a4f02b"
  issueCountsBySeverity: {high: 86, low: 466, medium: 76}
  high: 86
  low: 466
  medium: 76
  lastTestedDate: "2021-05-13T20:33:48.883Z"
  name: "testacctconf/repo:firsttry"
  numActiveSuspiciousTrails: null
  numActiveThreatTrails: null
  numDetections: null
  type: "deb"

** ***/

const snykDiscoveryMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Name',
        label: 'Image Name',
        sortable: true,
        'min-width': 250,
        name: 'name'
      },
      {
        datatype: 'string',
        description: 'Image Id',
        label: 'Image Id',
        sortable: true,
        'min-width': 150,
        name: 'imageId'
      },
      {
        datatype: 'string',
        description: 'Name',
        label: 'Hosts Deployed',
        sortable: true,
        'min-width': 250,
        name: 'name2'
      },
      {
        datatype: 'string',
        description: 'Num of Active Suspicious Trails',
        label: 'Active Suspicious Trails',
        sortable: true,
        'min-width': 200,
        name: 'numActiveSuspiciousTrails'
      },
      {
        datatype: 'string',
        description: 'Num Active Threat Trails',
        label: 'Active Threat Trails',
        sortable: true,
        'min-width': 175,
        name: 'numActiveThreatTrails'
      },
      {
        datatype: 'string',
        description: 'Num of Detections',
        label: 'Num of Detections',
        sortable: true,
        'min-width': 150,
        name: 'numDetections'
      },
      {
        datatype: 'string',
        description: 'Issue Counts By Severity',
        label: 'Vulnerability Score',
        sortable: true,
        'min-width': 225,
        name: 'issueCountsBySeverity'
      },
      {
        datatype: 'string',
        description: 'Type',
        label: 'Type',
        sortable: true,
        'min-width': 150,
        name: 'type'
      },
      {
        datatype: 'string',
        description: 'Last Tested Date',
        label: 'Last Tested Date',
        sortable: true,
        'min-width': 150,
        name: 'lastTestedDate'
      }
    ]
  }
}

export { snykDiscoveryMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/hosts/snykdiscovery-meta.js